var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.883h60v53.25h-60Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.723 20.563h21.75V47h-21.75Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 48h8v6.313h-8Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f158c3",
    d: "M67.156 27.195c0-9.043-7.324-16.37-16.36-16.37-5.487 0-10.327 2.706-13.296 6.847-2.969-4.14-7.809-6.848-13.293-6.848-9.039 0-16.363 7.328-16.363 16.371 0 1.278.164 2.52.441 3.715C10.56 45.031 26.25 59.93 37.5 64.023c11.246-4.093 26.941-18.992 29.21-33.109.282-1.2.446-2.437.446-3.719Zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.043 46.133c-1.715 0-3.105-1.375-3.105-3.07v-4.09c0-1.696 1.39-3.067 3.105-3.067.625-.008 6.215-1.023 6.215-5.113 0-2.047-2.07-4.094-5.18-4.094-2.527 0-4.14 2.047-4.14 3.07 0 1.696-1.391 3.067-3.11 3.067-1.715 0-3.105-1.371-3.105-3.066 0-4.989 4.742-9.204 10.355-9.204 8.29 0 11.395 6.118 11.395 11.247 0 4.242-2.36 7.48-6.641 9.125-.934.359-1.855.597-2.68.761v1.364c0 1.695-1.39 3.07-3.109 3.07Zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.152 51.246c0 .406-.082.797-.238 1.172a3.031 3.031 0 0 1-.672.996c-.293.29-.629.512-1.008.664a3.114 3.114 0 0 1-1.191.234c-.41 0-.809-.078-1.188-.234a2.96 2.96 0 0 1-1.007-.664 3.042 3.042 0 0 1-.676-3.344 3.083 3.083 0 0 1 1.683-1.66 3.095 3.095 0 0 1 1.188-.234c.414 0 .809.078 1.191.234a3.072 3.072 0 0 1 1.918 2.836Zm0 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionPink);
export default __webpack_public_path__ + "static/media/question-pink.8747074297bd6359fcaffecc650f380c.svg";
export { ForwardRef as ReactComponent };